

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.DuPb4eEA.js","_app/immutable/chunks/disclose-version.DZaQXHkE.js","_app/immutable/chunks/runtime.CkDI4bGX.js","_app/immutable/chunks/legacy.CMQtmpCj.js","_app/immutable/chunks/slot.CZzdtJAX.js"];
export const stylesheets = ["_app/immutable/assets/0.DSlYQ1ki.css"];
export const fonts = ["_app/immutable/assets/roboto-regular.BHeBnKzs.ttf","_app/immutable/assets/roboto-medium.CFKDKRMh.ttf","_app/immutable/assets/sofia-pro-regular.DcCN7_ks.ttf","_app/immutable/assets/sofia-pro-bold.LtCaxDoQ.ttf","_app/immutable/assets/sofia-pro-black.DVGQlFTu.otf"];
